module.exports = __webpack_public_path__ + "static/ferie 2025-2-364eac5beae293b539cf99dadf147fed.png";